import React from 'react';

function BCAAMembership(props) {
    return (
        <React.Fragment>
            <label>
                <div className="custom-control custom-switch">
                    <input
                        type="checkbox"
                        value={props.data.member}
                        checked={props.data.member}
                        className="custom-control-input"
                        id="customSwitch1"
                        onChange={() => props.updateField('member', !props.data.member)}
                    />
                    <label className="custom-control-label" htmlFor="customSwitch1">
                        Are you a BCAA Member?
                    </label>
                </div>
            </label>
            {props.data.member ? (
                <form>
                    <div className="form-row mb-2">
                        <label htmlFor="license-number" className="blue small col-4 mb-0">
                            Membership number
                        </label>
                        <div className={'col-1 bcaa-prefix'}>
                            <b>620</b>
                        </div>
                        <div className="col-2">
                            <input
                                className="form-control"
                                pattern="[0-9.]+"
                                maxLength="3"
                                type="text"
                                value={props.data.input1}
                                onChange={e => props.updateField('input1', e.target.value)}
                            />
                        </div>
                        <div className="col-3">
                            <input
                                className="form-control"
                                pattern="[0-9.]+"
                                maxLength="7"
                                type="text"
                                value={props.data.input2}
                                onChange={e => props.updateField('input2', e.target.value)}
                            />
                        </div>
                        <div className="col-2">
                            <input
                                className="form-control"
                                pattern="[0-9.]+"
                                maxLength="3"
                                type="text"
                                value={props.data.input3}
                                onChange={e => props.updateField('input3', e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="form-row mb-2">
                        <label htmlFor="member-since" className="blue small col-4 mb-0">
                            Member since year (YYYY)
                        </label>
                        <div className="col">
                            <input
                                name="member-since"
                                pattern="[0-9.]+"
                                className="form-control"
                                type="text"
                                value={props.data.memberSince}
                                maxLength={4}
                                onChange={e => props.updateField('memberSince', e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="form-row mb-2">
                        <label htmlFor="postal-code" className="blue small col-4 mb-0">
                            Postal Code
                        </label>
                        <div className="col">
                            <input
                                className="form-control"
                                name={'postal-code'}
                                type="text"
                                value={props.data.postalCode}
                                maxLength={12}
                                onChange={e => props.updateField('postalCode', e.target.value)}
                            />
                        </div>
                    </div>
                </form>
            ) : null}
        </React.Fragment>
    );
}
export default BCAAMembership;
